var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScannerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "236px",
    height: "235px",
    viewBox: "0 0 236 235",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Scanner Button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NEU",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landingpage-Copy",
    transform: "translate(-602, -266)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scanner-Button",
    transform: "translate(602.6662, 266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(50.3338, 31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Clip",
    x: 48.5,
    y: 66,
    width: 35,
    height: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5,29.7 L49.5,49.5 L29.7,49.5 L29.7,29.7 L49.5,29.7 Z M59.4,19.8 L19.8,19.8 L19.8,59.4 L59.4,59.4 L59.4,19.8 Z M49.5,82.5 L49.5,102.3 L29.7,102.3 L29.7,82.5 L49.5,82.5 Z M59.4,72.6 L19.8,72.6 L19.8,112.2 L59.4,112.2 L59.4,72.6 Z M102.3,29.7 L102.3,49.5 L82.5,49.5 L82.5,29.7 L102.3,29.7 Z M112.2,19.8 L72.6,19.8 L72.6,59.4 L112.2,59.4 L112.2,19.8 Z M72.6,72.6 L82.5,72.6 L82.5,82.5 L72.6,82.5 L72.6,72.6 Z M82.5,82.5 L92.4,82.5 L92.4,92.4 L82.5,92.4 L82.5,82.5 Z M92.4,72.6 L102.3,72.6 L102.3,82.5 L92.4,82.5 L92.4,72.6 Z M72.6,92.4 L82.5,92.4 L82.5,102.3 L72.6,102.3 L72.6,92.4 Z M82.5,102.3 L92.4,102.3 L92.4,112.2 L82.5,112.2 L82.5,102.3 Z M92.4,92.4 L102.3,92.4 L102.3,102.3 L92.4,102.3 L92.4,92.4 Z M102.3,82.5 L112.2,82.5 L112.2,92.4 L102.3,92.4 L102.3,82.5 Z M102.3,102.3 L112.2,102.3 L112.2,112.2 L102.3,112.2 L102.3,102.3 Z M132,33 L118.8,33 L118.8,13.2 L99,13.2 L99,0 L132,0 L132,33 Z M132,132 L132,99 L118.8,99 L118.8,118.8 L99,118.8 L99,132 L132,132 Z M0,132 L33,132 L33,118.8 L13.2,118.8 L13.2,99 L0,99 L0,132 Z M0,0 L0,33 L13.2,33 L13.2,13.2 L33,13.2 L33,0 L0,0 Z",
    id: "Vector",
    fill: "#0d4453"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannerLogo);
export default __webpack_public_path__ + "static/media/ScannerLogo.0664782ffef0c4cac97accc26fe0a82f.svg";
export { ForwardRef as ReactComponent };